exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/data/efun/gw-template-pre/client/smsgz/assets","/static":"/data/efun/gw-template-pre/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c2a3a86","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./client/smsgz/layouts/default.vue
// module id = HwB3
// module chunks = 1